import React from "react";
import { Link, useNavigate } from "react-router-dom";

const NotFound: React.FC = () => {
  const navigate = useNavigate();
  const goBack = () => {
    navigate(-1);
  };
  return (
    <div className="h-full flex items-center justify-center ">
      <div className="text-center px-6 py-10 rounded-xl  w-full">
        <h1 className="text-[120px] font-bold text-goldenAmberText">404</h1>
        <h2 className="text-2xl font-semibold text-gray-800 mb-2">
          Page Not Found
        </h2>
        <p className="text-gray-500 mb-6">
          Sorry, the page you’re looking for doesn’t exist or has been moved.
        </p>
        <p
          onClick={goBack}
          className="inline-block cursor-pointer px-6 py-3 bg-darkTealBlue text-white font-semibold rounded-lg shadow-md  transition duration-300"
        >
          Go Back Dashboard
        </p>
      </div>
    </div>
  );
};

export default NotFound;
